<template>
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 400 108"
    :width="props.width"
    :height="props.height"
    :style="{ fill: props.fill }"
  >
    <polygon
      :class="{ st0: !props.fill }"
      points="94.13 94.75 86.81 94.75 86.81 88.89 84.9 88.89 84.9 103.01 86.81 103.01 86.81 96.55 94.13 96.55 94.13 103.01 96.05 103.01 96.05 88.89 94.13 88.89 94.13 94.75"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M109.96,93.32c-2.83,0-4.89,2.13-4.89,4.97s1.88,4.97,4.87,4.97c1.82,0,3.19-.64,4.19-1.94l-1.36-1.04c-.7.86-1.5,1.42-2.59,1.42-1.66,0-3.19-1.1-3.19-2.75h7.58v-.64c0-2.43-1.28-4.99-4.61-4.99ZM106.99,97.51c0-1.26,1.16-2.75,2.93-2.75s2.69,1.18,2.73,2.75h-5.67Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M130.88,96.47c0-1.64-1.16-3.15-3.95-3.15-1.32,0-2.75.46-3.75,1.4l1.08,1.12c.66-.5,1.32-1.08,2.69-1.08,1.54,0,2.25,1.02,2.25,2v.4h-1.32c-2.87,0-5.21.84-5.21,3.27,0,1.84,1.52,2.83,3.27,2.83,1.44,0,2.51-.46,3.31-1.68h.04c0,.48.02.96.06,1.44h1.6c-.06-.5-.08-1.06-.08-1.72v-4.83ZM129.2,99.06c0,1.28-.7,2.75-2.69,2.75-1.24,0-2.04-.46-2.04-1.54,0-1.52,2.08-1.82,3.77-1.82h.96v.6Z"
    />
    <rect :class="{ st0: !props.fill }" x="140.04" y="87.93" width="1.8" height="15.08" />
    <path
      :class="{ st0: !props.fill }"
      d="M153.59,99.4v-4.29h2.57v-1.56h-2.57v-2.65h-1.8v2.65h-2.08v1.56h2.08v4.93c0,1.52.04,3.21,2.81,3.21.36,0,1.2-.08,1.62-.32v-1.64c-.36.22-.86.28-1.28.28-1.36,0-1.36-1.12-1.36-2.17Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M169.84,93.32c-1.46,0-2.65.7-3.11,1.7h-.04v-7.08h-1.8v15.08h1.8v-4.87c0-2.19,1.14-3.15,2.63-3.15,1.14,0,2.15.66,2.15,2.43v5.59h1.8v-6.09c0-2.51-1.6-3.61-3.43-3.61Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M206.72,95.49h-2.18l-1.78,2.89-2.79-2.91c1.42-.74,2.93-1.85,2.93-3.63,0-2.13-1.67-3.19-3.65-3.19s-3.77,1.16-3.77,3.31c0,1.38.76,2.31,1.66,3.27-1.72.82-3.21,2.07-3.21,4.05s1.44,4.09,4.63,4.09c1.9,0,3.13-.8,4.33-2.23l1.74,1.88h2.57l-3.21-3.29,2.73-4.23ZM199.27,90.32c1,0,1.72.58,1.72,1.52,0,1.28-1.22,1.96-2.19,2.49-.62-.62-1.4-1.42-1.4-2.36,0-1.06.86-1.65,1.87-1.65ZM198.61,101.7c-1.36,0-2.65-1.1-2.65-2.47,0-1.46,1.24-2.21,2.37-2.87l3.41,3.55c-.74.88-1.76,1.8-3.13,1.8Z"
    />
    <polygon
      :class="{ st0: !props.fill }"
      points="232.04 100.38 232 100.38 227.85 88.89 225.64 88.89 231.09 103.01 232.88 103.01 238.45 88.89 236.35 88.89 232.04 100.38"
    />
    <rect :class="{ st0: !props.fill }" x="246.24" y="93.56" width="1.8" height="9.46" />
    <path
      :class="{ st0: !props.fill }"
      d="M247.13,88.85c-.72,0-1.32.6-1.32,1.32s.6,1.32,1.32,1.32,1.32-.6,1.32-1.32-.6-1.32-1.32-1.32Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M259.78,99.4v-4.29h2.57v-1.56h-2.57v-2.65h-1.8v2.65h-2.08v1.56h2.08v4.93c0,1.52.04,3.21,2.81,3.21.36,0,1.2-.08,1.62-.32v-1.64c-.36.22-.86.28-1.28.28-1.36,0-1.36-1.12-1.36-2.17Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M278.82,96.47c0-1.64-1.16-3.15-3.95-3.15-1.32,0-2.75.46-3.75,1.4l1.08,1.12c.66-.5,1.32-1.08,2.69-1.08,1.54,0,2.25,1.02,2.25,2v.4h-1.32c-2.87,0-5.21.84-5.21,3.27,0,1.84,1.52,2.83,3.27,2.83,1.44,0,2.51-.46,3.31-1.68h.04c0,.48.02.96.06,1.44h1.6c-.06-.5-.08-1.06-.08-1.72v-4.83ZM277.15,99.06c0,1.28-.7,2.75-2.69,2.75-1.24,0-2.04-.46-2.04-1.54,0-1.52,2.08-1.82,3.77-1.82h.96v.6Z"
    />
    <rect :class="{ st0: !props.fill }" x="287.99" y="87.93" width="1.8" height="15.08" />
    <path
      :class="{ st0: !props.fill }"
      d="M300.08,88.85c-.72,0-1.32.6-1.32,1.32s.6,1.32,1.32,1.32,1.32-.6,1.32-1.32-.6-1.32-1.32-1.32Z"
    />
    <rect :class="{ st0: !props.fill }" x="299.18" y="93.56" width="1.8" height="9.46" />
    <path
      :class="{ st0: !props.fill }"
      d="M312.73,99.4v-4.29h2.57v-1.56h-2.57v-2.65h-1.8v2.65h-2.08v1.56h2.08v4.93c0,1.52.04,3.21,2.81,3.21.36,0,1.2-.08,1.62-.32v-1.64c-.36.22-.86.28-1.28.28-1.36,0-1.36-1.12-1.36-2.17Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M327.82,100.94h-.04l-2.81-7.38h-2.07l3.93,9.52-.58,1.5c-.36.94-.7,1.56-1.84,1.56-.36,0-.74-.08-1.08-.22l-.22,1.64c.5.2,1.06.26,1.6.26,1.97,0,2.59-1.12,3.23-2.75l4.49-11.49h-1.94l-2.67,7.38Z"
    />
    <circle :class="{ st0: !props.fill }" cx="90.93" cy="7.25" r="7.05" />
    <rect :class="{ st0: !props.fill }" x="84.86" y="19.36" width="12.16" height="41.02" />
    <path
      :class="{ st0: !props.fill }"
      d="M126.55,60.76c5.62,0,10.42-3.36,12.32-6.23h.17v5.84h11.41V.2h-12.4v24.02h-.17c-2.81-3.85-7.61-5.24-12.73-5.24-11.41,0-18.35,10.16-18.35,21.22,0,12.04,7.85,20.56,19.76,20.56ZM129.11,29.67c6.2,0,9.92,4.11,9.92,10.12s-3.72,10.12-9.92,10.12-9.92-4.11-9.92-10.12,3.72-10.12,9.92-10.12Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M178.39,60.76c5.62,0,10.42-3.36,12.32-6.23h.17v5.84h11.41V19.36h-12.4v4.86h-.17c-2.81-3.85-7.61-5.24-12.73-5.24-11.41,0-18.35,10.16-18.35,21.22,0,12.04,7.85,20.56,19.76,20.56ZM180.96,29.67c6.2,0,9.92,4.11,9.92,10.12s-3.72,10.12-9.92,10.12-9.92-4.11-9.92-10.12,3.72-10.12,9.92-10.12Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M242.03,61.25c7.94,0,16.13-3.19,20.95-10.07l-10.64-7.94c-2.62,3.93-6.79,6.22-11.95,6.22-9.25,0-16.37-7.86-16.37-18.66s7.12-18.66,16.78-18.66c4.75,0,8.43,1.72,10.97,4.75l9.82-8.02c-4.91-6.3-13.1-8.51-19.56-8.51-18.09,0-31.27,11.87-31.27,30.45s13.18,30.45,31.27,30.45Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M289.99,60.75c12.28,0,22.1-8.19,22.1-20.87s-9.82-20.87-22.1-20.87-22.1,8.19-22.1,20.87,9.82,20.87,22.1,20.87ZM289.99,29.81c6.14,0,9.82,4.09,9.82,10.07s-3.68,10.07-9.82,10.07-9.82-4.09-9.82-10.07,3.68-10.07,9.82-10.07Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M332.72,26.35h-.16v-6.99h-12.28v41.02h12.28v-17.25c0-7.94,1.15-13.34,10.48-13.34,1.8,0,3.52.33,5.24.82v-11.21c-1.15-.33-2.7-.41-4.09-.41-5.4,0-8.84,2.54-11.46,7.37Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M380.44,18.77c-5.57,0-10.31,3.36-12.2,6.22h-.16v-5.6h-11.3v58.31h12.28v-22.42h.16c2.78,3.85,7.53,5.24,12.61,5.24,11.3,0,18.17-10.15,18.17-21.2,0-12.03-7.78-20.55-19.56-20.55ZM377.9,49.71c-6.14,0-9.82-4.09-9.82-10.07s3.68-10.07,9.82-10.07,9.82,4.09,9.82,10.07-3.68,10.07-9.82,10.07Z"
    />
    <polygon
      :class="{ st0: !props.fill }"
      points="38.92 51.07 38.7 51.07 19.52 .2 0 .2 31.03 77.83 44.73 77.83 76.75 .2 58.44 .2 38.92 51.07"
    />
    <rect :class="{ st0: !props.fill }" x="84.86" y="74.99" width="247.68" height="2.77" />
  </svg>
</template>

<script setup lang="ts">
interface SVGProps {
  height: string
  width: string
  fill?: string
}

const props = defineProps<SVGProps>()
</script>

<style scoped>
.st0 {
  fill: #0d76b0;
}
</style>
